import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LoginModel} from '../models/login.model';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AuthenticationService, PermissionService} from '../../_services';
import {TranslateService} from '@ngx-translate/core';
import {CodeInputComponent} from 'angular-code-input';
import {environment} from '../../../environments/environment';
import {completePostLogin} from '../models/post-login';

@Component({
  moduleId: module.id,
  selector: 'app-login',
  templateUrl: `../views/login.component.html`,
  styleUrls: ['../styles/auth-style.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    ConfirmationService,
    MessageService
  ]
})
export class LoginComponent implements OnInit {
  public credentials: LoginModel;
  public displayTermsAndConditions = false;
  public passwordTypeField = true;
  returnUrl: string;
  resetEmail = '';
  resesetEmailObj = {
    email: '',
    password: '',
    code: ''
  };
  resetPassword = false;
  public isDropdownVisible = false;

  sendingEmail = false;

  verifyingCode = false;
  loadingCode = false;
  incorrectCode = false;
  code = '';
  resettingPassword = false;
  updatingPassword = false;
  @ViewChild('codeInput') codeInput !: CodeInputComponent;

  public showBrowserAlert = true;
  public isChrome = navigator.userAgent.indexOf("Chrome") != -1;
  public agreed = localStorage.getItem('chrome_suggestion_alert');

  public logoUrl = environment.logoUrl;
  public agencyName = environment.agencyName;

  public currentLanguage = localStorage.getItem('Language');

  constructor(
    private authService: AuthenticationService,
    private permissionService: PermissionService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private translate: TranslateService,
    private confirmationService: ConfirmationService
  ) {
    this.credentials = new LoginModel();
    this.credentials.email = '';
    this.credentials.password = '';
  }

  ngOnInit() {
    if(this.route.snapshot.queryParams && this.route.snapshot.queryParams.type == "reset") {
      this.resetPassword = true;
      this.resetEmail = this.route.snapshot.queryParams.email;
      if (this.resetEmail.length) {
        this.resetEmail = this.resetEmail.toLowerCase();
      }
    }
    this.currentLanguage = localStorage.getItem('Language');
  }

  agreeOnChromeAlert() {
    localStorage.setItem('chrome_suggestion_alert', JSON.stringify(new Date()));
    this.showBrowserAlert = false
  }

  hideDropdown() {
    this.isDropdownVisible = false;
  }

  onSubmit(profileForm) {
    this.credentials.incorrect = false;
    if (!profileForm.valid) {
      return;
    }

    this.authService.login(this.credentials).subscribe(
      response => {
        if (response.status === '2fa_enrolment_required') {
          // [A] Mandatory enrolment. Same rule as the token below: a bearer
          // credential travels in router state, never in the URL.
          this.router.navigate(['/passkey-enrol'], {
            state: {enrolmentToken: response.enrolment_token}
          });
          return;
        }
        if (response.status === '2fa_required') {
          // The token is a bearer credential: it travels in router state, never
          // in the URL, so it stays out of history and referrer headers.
          this.router.navigate(['/passkey-verify'], {
            state: {
              loginToken: response.login_token,
              hasRecoveryCodes: response.has_recovery_codes
            }
          });
          return;
        }
        if (response.status === 'success') {
          // JS-1396: the temp-password redirect, the currentUser write, the
          // language switch and the whole permission ladder now live in one
          // place, shared with the two passkey screens (see post-login.ts).
          // /login is the one caller with a `token` on a temp-password
          // response, so it is the one that can deep-link into the reset flow.
          // JS-1920 (2026-10-21): the agency-client/profile :id change (now
          // client_id, was agency_id) is applied inside post-login.ts so every
          // caller (login + both passkey screens) uses the same URL shape.
          completePostLogin(response, {
            router: this.router,
            translate: this.translate,
            tempPasswordDestination: 'password-reset'
          });
        } else if (response.status === 'not verified') {
            this.confirmationService.confirm({
                header: this.translate.instant("Confirmation"),
                message: `${this.translate.instant('Resend verification eMail?')}`,
                accept: () => {
                    // this.resendConfirmEmail();
                }
            });
        } else {
          this.credentials.incorrect = true;
          this.credentials.message = response.message;
        }
      },
      err => {
      });
    return;
  }

  submitReset(resetForm) {
    if (!resetForm.valid) {
      return;
    }
    this.sendingEmail = true;
    this.resesetEmailObj.email = this.resetEmail;
    this.authService.resetRequest(this.resesetEmailObj).subscribe(
      response => {
        this.sendingEmail = false;
        this.verifyingCode = true;
        this.translate.get('email to reset passwort was sent successfully.').subscribe( res => {
            this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: this.translate.instant(res)});
        })
      },
      error => {
        this.sendingEmail = false;
      },
    );
  }

  resendPasswordResetCode() {
    this.loadingCode = true;
    this.incorrectCode = false;
    this.authService.resendPasswordResetCode(this.resesetEmailObj).subscribe(
      response => {
        this.loadingCode = false;
        this.codeInput.reset();
        this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: this.translate.instant("code sent sucessfully")});
      },
      error => {
        this.loadingCode = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: this.translate.instant("failed to send code")});
      }
    );
  }

  onCodeChanged(code: string) {
    if(code.length < 4) {
      this.incorrectCode = false;
    }
    this.code = code;
  }

  // this called only if user entered full code
  onCodeCompleted(code: string) {
    this.loadingCode = true;
    this.resesetEmailObj.code = code;
    this.authService.isResetPasswordCodeValid(this.resesetEmailObj).subscribe(
      response => {
        this.loadingCode = false;
        console.log('its valid');
        // go to new password form
        this.verifyingCode = false;
        this.resettingPassword = true;
      },
      error => {
        this.incorrectCode = true;
        this.loadingCode = false;
      }
    )
  }

  verify(){
    this.loadingCode = true;
    if(this.code.length == 4) {
      this.resesetEmailObj.code = this.code;
      this.authService.isResetPasswordCodeValid(this.resesetEmailObj).subscribe(
        response => {
          this.loadingCode = false;
          console.log('its valid');
          // go to new password form
          this.verifyingCode = false;
          this.resettingPassword = true;
        },
        error => {
          this.incorrectCode = true;
          this.loadingCode = false;
        }
      )
    } else {
      this.loadingCode = true;
      this.translate.get('incorrect code').subscribe(
        res => {
          this.loadingCode = false;
          this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
          this.incorrectCode = true;
          this.loadingCode = false;
        },
      );
    }
  }

  updatePassword() { 
    const passwordPattern = this.resesetEmailObj.password;
    this.updatingPassword = true;

    if (!passwordPattern.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,.\/:;<=>?@\[\\\]^_`{|}~-]).{8,}$/)) {
     this.translate.get('must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters').subscribe(
       res => {
          this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res, life: 10000});
        });
      this.updatingPassword = false;
      return;
    }

    this.authService.updatePassword(this.resesetEmailObj).subscribe(
      response => {
        this.updatingPassword = false;
        this.translate.get("password changed successfully").subscribe(res => {
          console.log(response)
            this.messageService.add({severity: 'success', summary: this.translate.instant('Success!'), detail: res});
        });
       window.location.reload();
      },
      error => {
        this.updatingPassword = false;
        this.translate.get('failed to change password').subscribe(res => {
          this.messageService.add({severity: 'error', summary: this.translate.instant('Error!'), detail: res});
        });
      }
    );
  }

  getTermsAndConditionsUrl(): string {
    switch (this.currentLanguage) {
      case 'de':
        return 'https://job.rocks/allgemeine-geschaftsbedingungen';
      case 'fr':
        return 'https://job.rocks/fr/conditions-generales';
      case 'it':
        return 'https://job.rocks/it/condizioni-generali';
      default:
        return 'https://job.rocks/en/terms-and-conditions/';
    }
  }
}

